"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBuyerOffersResponseDto = instanceOfBuyerOffersResponseDto;
exports.BuyerOffersResponseDtoFromJSON = BuyerOffersResponseDtoFromJSON;
exports.BuyerOffersResponseDtoFromJSONTyped = BuyerOffersResponseDtoFromJSONTyped;
exports.BuyerOffersResponseDtoToJSON = BuyerOffersResponseDtoToJSON;
exports.BuyerOffersResponseDtoToJSONTyped = BuyerOffersResponseDtoToJSONTyped;
var PaginationDetailsDto_1 = require("./PaginationDetailsDto");
var BuyerOfferDto_1 = require("./BuyerOfferDto");
/**
 * Check if a given object implements the BuyerOffersResponseDto interface.
 */
function instanceOfBuyerOffersResponseDto(value) {
    if (!('offers' in value) || value['offers'] === undefined)
        return false;
    if (!('pagination' in value) || value['pagination'] === undefined)
        return false;
    return true;
}
function BuyerOffersResponseDtoFromJSON(json) {
    return BuyerOffersResponseDtoFromJSONTyped(json, false);
}
function BuyerOffersResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'offers': (json['offers'].map(BuyerOfferDto_1.BuyerOfferDtoFromJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoFromJSON)(json['pagination']),
    };
}
function BuyerOffersResponseDtoToJSON(json) {
    return BuyerOffersResponseDtoToJSONTyped(json, false);
}
function BuyerOffersResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'offers': (value['offers'].map(BuyerOfferDto_1.BuyerOfferDtoToJSON)),
        'pagination': (0, PaginationDetailsDto_1.PaginationDetailsDtoToJSON)(value['pagination']),
    };
}
